import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

interface Props {
  onEnterRequirements?: () => void;
  onSelectSubmission?: () => void;
  onSetupFinanceProgram?: () => void;
}

export const LenderRequirementsGatherSection = ({
  onEnterRequirements,
  onSelectSubmission,
  onSetupFinanceProgram,
}: Props) => {
  const classes = useStyles();

  return (
    <Box>
      <Box className={classes.headerRow}>
        <Box>
          <Typography className={classes.sectionTitle}>
            How would you like to enter lender insurance requirements?
          </Typography>
          <Typography className={classes.sectionSubtitle}>
            Insurance requirements are needed to verify coverage and submit the COI.
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box className={classes.card}>
            <Box className={classes.cardTop}>
              <Box className={classes.cardIconMuted}>
                <EditOutlinedIcon fontSize="small" />
              </Box>
              <Typography className={classes.cardTitle}>Manual Entry</Typography>
            </Box>

            <Typography className={classes.cardBody}>
              Manually enter lender insurance requirements for this deal. Best option if finance programs are not set up
              yet.
            </Typography>

            <Button
              variant="outlined"
              color="primary"
              className={classes.cta}
              onClick={() => (onEnterRequirements ? onEnterRequirements() : undefined)}
            >
              ENTER REQUIREMENTS
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box className={classes.card}>
            <Box className={classes.cardTop}>
              <Box className={classes.cardIconMuted}>
                <DescriptionOutlinedIcon fontSize="small" />
              </Box>
              <Typography className={classes.cardTitle}>Submission &amp; Finance Program</Typography>
            </Box>

            <Typography className={classes.cardBody}>
              Apply insurance requirements from an approved submission using a linked finance program.
            </Typography>

            <Button
              variant="outlined"
              color="primary"
              className={classes.cta}
              onClick={() => (onSelectSubmission ? onSelectSubmission() : undefined)}
            >
              SELECT SUBMISSION
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles({
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
    flexWrap: 'wrap',
    marginBottom: '10px',
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '14px',
  },
  sectionSubtitle: {
    marginTop: '6px',
    fontSize: '12px',
    color: '#4b5563',
  },
  rightTools: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  saveTimeWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '2px',
  },
  saveTimeText: {
    fontSize: '12px',
    color: '#6b7280',
  },
  infoIcon: {
    fontSize: '16px',
    color: '#2563eb',
  },
  linkBtn: {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '12px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },

  card: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '14px',
    backgroundColor: '#f9fafb',
    height: '100%',
  },
  cardTop: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  cardIconMuted: {
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    backgroundColor: '#e5e7eb',
    color: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: '13px',
  },
  cardBody: {
    marginTop: '10px',
    fontSize: '12px',
    color: '#4b5563',
    marginBottom: '12px',
  },
  cta: {
    fontSize: '12px',
    fontWeight: 600,
  },
});
